var map = {
	"./decidim/avatar-multiuser.png": 85140,
	"./decidim/brands/google.svg": 99067,
	"./decidim/cc-badge.png": 28694,
	"./decidim/decidim-logo.svg": 7382,
	"./decidim/default-avatar.svg": 15794,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 22294,
	"./decidim/icons.svg": 11269,
	"./decidim/pattern.png": 68626,
	"./decidim/placeholder-card-g.svg": 13343,
	"./decidim/placeholder-card-l.svg": 56516,
	"./decidim/placeholder.jpg": 53755,
	"./decidim/remixicon.symbol.svg": 74323,
	"./decidim/vendor/leaflet/layers-2x.png": 98806,
	"./decidim/vendor/leaflet/layers.png": 57421,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 44340,
	"./decidim/vendor/leaflet/marker-icon.png": 52883,
	"./decidim/vendor/leaflet/marker-shadow.png": 66984,
	"./decidim/vendor/social-share-button/douban.svg": 65346,
	"./decidim/vendor/social-share-button/email.svg": 12191,
	"./decidim/vendor/social-share-button/facebook.svg": 73313,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 6195,
	"./decidim/vendor/social-share-button/hacker_news.svg": 45139,
	"./decidim/vendor/social-share-button/linkedin.svg": 18511,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 99592,
	"./decidim/vendor/social-share-button/pinterest.svg": 85681,
	"./decidim/vendor/social-share-button/reddit.svg": 81505,
	"./decidim/vendor/social-share-button/telegram.svg": 86424,
	"./decidim/vendor/social-share-button/tumblr.svg": 9135,
	"./decidim/vendor/social-share-button/twitter.svg": 31278,
	"./decidim/vendor/social-share-button/vkontakte.svg": 20752,
	"./decidim/vendor/social-share-button/wechat.svg": 33051,
	"./decidim/vendor/social-share-button/whatsapp.svg": 27859,
	"./decidim/vendor/social-share-button/x.svg": 40663,
	"./decidim/vendor/social-share-button/xing.svg": 29217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15673;